import { type FC, useState, type ComponentProps } from "react";
import { Presentation } from "./Presentation";

type Props = Omit<ComponentProps<typeof Presentation>, "isShow" | "onClose" | "onClick">;

export const DivisionDetailModal: FC<Props> = ({
  divisionName,
  divisionDescription,
  sections,
  imagesPath,
  entryNote,
  entryUrl,
}) => {
  const [isShow, setIsShow] = useState(false);
  const handleOpenModal = () => setIsShow(true);
  const handleCloseModal = () => setIsShow(false);

  return (
    <Presentation
      isShow={isShow}
      onClose={handleCloseModal}
      onClick={handleOpenModal}
      divisionName={divisionName}
      divisionDescription={divisionDescription}
      sections={sections}
      imagesPath={imagesPath}
      entryNote={entryNote}
      entryUrl={entryUrl}
    />
  );
};
